import {UserRole} from "@/shared/enums/UserRolesEnums";
import DeletedRecordsDefaultView from "@/views/App/DeletedRecords/DeletedRecordsDefaultView.vue";
import DeletedRecords from "@/views/App/DeletedRecords/DeletedRecords.vue";
import DeletedOfficeList from "@/views/App/DeletedRecords/Office/List.vue";
import DeletedClientList from "@/views/App/DeletedRecords/Client/List.vue";
import DeletedUserList from "@/views/App/DeletedRecords/User/List.vue";
import DeletedUnemployedList from "@/views/App/DeletedRecords/Unemployed/List.vue";
import DeletedCoursePrivateCoachingList from "@/views/App/DeletedRecords/Course/PrivateCoachingList.vue";
import DeletedCourseGroupCoachingList from "@/views/App/DeletedRecords/Course/GroupCoachingList.vue";
import DeletedCoursePrivateLearningCoachingList from "@/views/App/DeletedRecords/Course/PrivateLearningCoachingList.vue";

const routesDeletedRecords = [
    {
        path: "deleted-records",
        name: "deletedRecords",
        component: DeletedRecordsDefaultView,
        children: [
            {
                path: "",
                name: "deletedRecordsHome",
                component: DeletedRecords,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_HR, UserRole.PERSONAL]},
            },
            {
                path: "/deleted-office",
                name: "deletedOfficeList",
                component: DeletedOfficeList,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "/deleted-client",
                name: "deletedClientList",
                component: DeletedClientList,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "/deleted-user",
                name: "deletedUserList",
                component: DeletedUserList,
                meta: {roles: [UserRole.ADMIN, UserRole.HEAD_OF_HR, UserRole.PERSONAL]},
            },
            {
                path: "/deleted-unemployed",
                name: "deletedUnemployedList",
                component: DeletedUnemployedList,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "/deleted-course-private-coaching",
                name: "deletedCoursePrivateCoachingList",
                component: DeletedCoursePrivateCoachingList,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "/deleted-course-group-coaching",
                name: "deletedCourseGroupCoachingList",
                component: DeletedCourseGroupCoachingList,
                meta: {roles: [UserRole.ADMIN]},
            },
            {
                path: "/deleted-course-private-learning-coaching",
                name: "deletedCoursePrivateLearningCoachingList",
                component: DeletedCoursePrivateLearningCoachingList,
                meta: {roles: [UserRole.ADMIN]},
            },
        ],
        meta: {roles: [UserRole.ADMIN]},
    },
];

export default routesDeletedRecords;